import { Image, Button } from "antd-mobile";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import imageWebtoonDefault from "../../images/btn_webtoon_default.png";
import imageWebtoonActive from "../../images/btn_webtoon_active.png";
import imageMotionComicsDefault from "../../images/btn_motioncomics_default.png";
import imageMotionComicsActive from "../../images/btn_motioncomics_active.png";
import imageAudioComicsDefault from "../../images/btn_audiocomics_default.png";
import imageAudioComicsActive from "../../images/btn_audiocomics_active.png";
import manIcon from "../../images/man.png";
import nearManIcon from "../../images/label_near_man.png";
import bottomLineIcon from "../../images/bottom_line.png";
import komixIcon from "../../images/label_komix.png";
import soundButtonUrl from "../../audio/button.mp3";

const Welcome = (props) => {

  const [audio, setAudio] = useState(null);

  useEffect(() => {
    if (audio == null) {
      let audioObj = new Audio(soundButtonUrl);
      audioObj.loop = false;
      // audioObj.play();
      setAudio(audioObj);
    }
  });

  return (
    <div
      style={{
        height: '100vh',
        backgroundSize: 'cover',
        background: `url('${process.env.PUBLIC_URL}/images/back_welcome.png')`
      }}
    >
      <div
        style={{ height: '50%', background: `url('${process.env.PUBLIC_URL}/images/back_welcome_half.png')` }}
      >
        <Image
          src={manIcon}
          width={"40%"}
          style={{
            borderRadius: 0,
            margin: "0px auto 10px auto",
            maxWidth: "25vh",
            padding: "50px 0 0 0",
            display: "flex",
          }}
        />
        <Image
          src={nearManIcon}
          width={"30%"}
          style={{
            borderRadius: 0,
            margin: "0px auto 10px auto",
            maxWidth: "25vh",
            padding: "10px 0 0 0",
            display: "flex",
          }}
        />
        <Image
          src={bottomLineIcon}
          width={"45%"}
          style={{
            borderRadius: 0,
            margin: "0px auto",
            maxWidth: "25vh",
            padding: "5px 0",
            display: "flex",
          }}
        />
        <Image
          src={komixIcon}
          width={"20%"}
          style={{
            borderRadius: 0,
            margin: "0px auto",
            maxWidth: "25vh",
            padding: "10px 0",
            display: "flex",
          }}
        />
      </div>
      <div
        style={{ height: '50%' }}
      >
        <div
          width={"100%"}
          style={{
            textAlign: 'center',
            borderRadius: 0,
            margin: "0px auto 10px auto",
            maxWidth: "30vh",
            padding: "30px 0 0 0",
            color: 'white'
          }}
        >
          <font style={{ fontSize: 16, textTransform: 'uppercase' }}>What ever you want!</font>
        </div>
        <Link to={"/webtoon"}>
          <img
            src={imageWebtoonDefault}
            width={"70%"}
            height={"auto"}
            fit="cover"
            style={{
              borderRadius: 0,
              margin: "0px auto 10px auto",
              maxWidth: "30vh",
              padding: "20px 0 0 0",
              display: "flex",
            }}
            onMouseOver={e => e.currentTarget.src = imageWebtoonActive}
            onMouseOut={e => e.currentTarget.src = imageWebtoonDefault}
            onClick={e => { audio.play(); }}
          />
        </Link>
        <Link to={"/movie"}>
          <img
            src={imageMotionComicsDefault}
            width={"70%"}
            height={"auto"}
            fit="cover"
            style={{
              borderRadius: 0,
              margin: "0px auto 10px auto",
              maxWidth: "30vh",
              padding: "20px 0 0 0",
              display: "flex",
            }}
            onMouseOver={e => e.currentTarget.src = imageMotionComicsActive}
            onMouseOut={e => e.currentTarget.src = imageMotionComicsDefault}
            onClick={e => { audio.play(); }}
          />
        </Link>
        <Link to={"/audio"}>
          <img
            src={imageAudioComicsDefault}
            width={"70%"}
            height={"auto"}
            fit="cover"
            style={{
              borderRadius: 0,
              margin: "0px auto 10px auto",
              maxWidth: "30vh",
              padding: "20px 0 0 0",
              display: "flex",
            }}
            onMouseOver={e => e.currentTarget.src = imageAudioComicsActive}
            onMouseOut={e => e.currentTarget.src = imageAudioComicsDefault}
            onClick={e => { audio.play(); }}
          />
        </Link>
      </div>
    </div>
  );
};

export default Welcome;
